export const handlePayer = (clientName: string) => {
    sessionStorage.setItem("client", clientName)

}